import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { getTopDestinations, ITopBookingsState } from '@store/slices';
import { ILoginState } from '@share/store/slices';
import { RootState, } from '@share/utils';
import { CarouselSlider } from '@components';

import { HotelSearchArgs, ITopBookings } from '@common-types';

import './style.scss';

interface IMapStateToProps {
  topBookingsStore: ITopBookingsState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  getTopDestinations: (account: any) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps { }

function ExploreDiscountComponent(props: IProps) {

  useEffect(() => {
    props.getTopDestinations(props.loginStore.account);
  }, [])

  const searchHandler: HotelSearchArgs = (location, checkIn, checkOut, rooms) => {
    const { loginStore, history } = props;
    const { account } = loginStore;
    const dates = { checkIn, checkOut };
    const room = rooms?.map((room) => ({ adultsCount: room.adultsCount, kidsAges: room.kidsAges }))
    history.push(`/${account?.name}/search?dates=${btoa(JSON.stringify(dates))}&location=${btoa(JSON.stringify(location))}&rooms=${btoa(JSON.stringify(room))}`,);
  };

  const { topDestinations, loading } = props.topBookingsStore;

  const destination: ITopBookings = topDestinations;
  const slidesToShow = (!destination?.items || destination?.items?.length >= 5) ? 5 : destination.items.length;

  if (!!destination?.items?.length && !loading) {
    return (
      <section>
        <div className="container explore-discount">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-0"><FormattedMessage id="dashboard.explore.discounts" /></h2>
              <p className="lead"><FormattedMessage id="dashboard.explore.discounts.message" /></p>
            </div>
          </div>

          <div className="row g-4 g-md-5">

            <CarouselSlider lazyLoad="progressive" slidesToShow={slidesToShow} className="explore-discount__carousel">
              {destination.items?.map((item, index) => (
                <div key={index} onClick={(e) => { e.preventDefault(), searchHandler(item.location, destination?.checkIn, destination?.checkOut, destination?.rooms) }} className="col-6 col-sm-4 col-lg-3 col-xl-2">
                  <div className="card bg-transparent text-center p-1 h-100 border-0">
                    <img src={item.image} className="rounded-circle" alt={item.location.name} />
                    <div className="card-body p-0 pt-3">
                      <h5 className="card-title">
                        <a href="#" className="stretched-link">
                          {item.location.name}
                        </a>
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
            </CarouselSlider>

          </div>
        </div>
      </section>
    );
  }

  return null;
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    topBookingsStore: state.topBookingsStore,
    loginStore: state.loginStore
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getTopDestinations
};

const ExploreDiscount = connect(mapStateToProps, mapDispatchToProps)(withRouter(ExploreDiscountComponent));
export { ExploreDiscount };